export interface IAnthem {
    link: string;
    source: "wikimedia";
}

export class Anthems {
    [key: string]: IAnthem
}



// WEBPACK FOOTER //
// ./src/app/shared/location/countries-data/models/anthems.model.ts